import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import FullPageLoader from "../constants/FullPageLoader";
import Dashboard from "../components/pages/Dashboard";
import Sale from "../components/pages/sale/Sale";
import React from "react";

const PrivateRoute = ({ openTabs, activePath, COMPONENT_MAP }) => {
  const { isUser, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <FullPageLoader isLoading />;

  if (!isUser) return <Navigate to="/login" />;

  return (
    <div className="tab-content-container">
      <div
        style={{
          display: location.pathname === "/dashboard" ? "block" : "none",
        }}
      >
        <Dashboard />
      </div>
      <div
        style={{ display: location.pathname === "/sale" ? "block" : "none" }}
      >
        <Sale isActive={location.pathname === "/sale"} />
      </div>

      {openTabs.map((tab) => (
        <div
          key={tab.path}
          style={{ display: activePath === tab.path ? "block" : "none" }}
        >
          {React.cloneElement(COMPONENT_MAP[tab.path], {
            isActive: activePath === tab.path,
          })}
        </div>
      ))}

      <Outlet />
    </div>
  );
};

export default PrivateRoute;
